/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type GoalType = "completable" | "continuous" | "%future added value";
export type GoalDetailsReview_goal = {
    readonly id: string;
    readonly type: GoalType;
    readonly status: number;
    readonly completion: number | null;
    readonly spacedRepetitionLevel: number;
    readonly reviewMode: {
        readonly spacedRepetition: boolean;
        readonly cycleBegin: {
            readonly days: number | null;
            readonly months: number | null;
        };
        readonly cycleGoal: {
            readonly days: number | null;
            readonly months: number | null;
        } | null;
    };
    readonly " $fragmentRefs": FragmentRefs<"GoalDetailsReviewStatus_goal" | "GoalDetailsReviewForm_goal" | "GoalDetailsReviews_goal">;
    readonly " $refType": "GoalDetailsReview_goal";
};
export type GoalDetailsReview_goal$data = GoalDetailsReview_goal;
export type GoalDetailsReview_goal$key = {
    readonly " $data"?: GoalDetailsReview_goal$data;
    readonly " $fragmentRefs": FragmentRefs<"GoalDetailsReview_goal">;
};



const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "days",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "months",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GoalDetailsReview_goal",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "completion",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "spacedRepetitionLevel",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ReviewMode",
      "kind": "LinkedField",
      "name": "reviewMode",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "spacedRepetition",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ReviewCycle",
          "kind": "LinkedField",
          "name": "cycleBegin",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ReviewCycle",
          "kind": "LinkedField",
          "name": "cycleGoal",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "GoalDetailsReviewStatus_goal"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "GoalDetailsReviewForm_goal"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "GoalDetailsReviews_goal"
    }
  ],
  "type": "Goal",
  "abstractKey": null
};
})();
(node as any).hash = 'a61302c0a5c74198c79b8fcf21b3304e';
export default node;
